"use client"
import React,{useState} from 'react'

type Delivery = {
    title: string;
    description: string;
    img: string;
    fullDes: string;
    closeIconType?: string
  };
  

  
export default function Businesses() {
    const [selectedDelivery, setSelectedDelivery] = useState<Delivery | null>(null);
    const deliveries = [
        {
          title: "Easy Driver Request",
          description:
            "With just a few clicks, you can request a driver to pick up goods from your branch and deliver them to your customers. It's that simple.",
          img: "/assets/wb-1.svg",
          closeIconType: 'white'
        },
        {
          title: "Online Store",
          description:
            "Set up your store for free, and let us take care of the deliveries. Focus on what you do best selling great products to your customers.",
            img: "/assets/wb-2.svg",
            closeIconType: 'white'
        },
        {
          title: "Push Notification",
          description:
            "Stay updated with real-time notifications for new orders, messages, and inventory alerts.",
          img: "/assets/wb-3.svg",
          closeIconType: 'white'
        },
        {
          title: "Instant Payouts",
          description:
            "Receive payments quickly and securely, with options for daily, weekly, or monthly payouts.",
          img: "/assets/wb-4.svg",
        },
      ];


      const handleDeliveryClick = (delivery: any) => {
        setSelectedDelivery(delivery);
      };
    
      const closeModal = () => {
        setSelectedDelivery(null);
      };
  return (

<div className="bg-[#fdfdfd] grid grid-cols-1 md:grid-cols-3 gap-x-7 gap-y-10 py-5">
  {deliveries.map((delivery, index) => (
    <div
      key={index}
      className={`bg-white cursor-pointer ${index === 3 ? 'md:col-start-2' : ''}`}
      onClick={() => handleDeliveryClick(delivery)}
    >
      <img src={delivery.img} className="w-full rounded-t-[15px]" />
      <div className="bg-white shadow-md rounded-bl-[10px] rounded-br-[10px] h-auto md:h-[200px] lg:h-auto min-h-[180px]">
        <div className="max-w-[400px]  px-5 py-5">
          <h2 className="text-xl sb-ac text-gray-800 mb-2">{delivery.title}</h2>
          <p className="text-gray-600 text-[15px]">{delivery.description}</p>
        </div>
      </div>
    </div>
  ))}



{selectedDelivery && (
        <div className="fixed inset-0 flex flex-row pt-[40px] md:pt-[50px] justify-center bg-black bg-opacity-50 px-5 md:px-0" onClick={closeModal}>
          <div className="w-[450px] rounded-[15px]  relative " >
            <button onClick={closeModal} className="absolute top-5 right-5 text-gray-500 hover:text-gray-700">
            <img src={selectedDelivery.closeIconType === 'white' ? "/assets/cancel-w.svg" : "/assets/cancel-ss.svg"} />
            </button>
            <img src={selectedDelivery.img} className="w-full h-[250px] md:h-[350px]  rounded-t-[15px] object-cover" alt={`${selectedDelivery.title} larger view`} />
            <div className='bg-white rounded-[15px] flex flex-col justify-center  items-center py-5 mt-[-20px] absolute px-5'> 
                  <div className='absolute top-[-20px] md:top-[-30px] right-[-10px] md:right-[-20px]'> 
                    <img src="/assets/cms.svg" className='w-[140px] md:w-auto' />
                  </div>
            <h2 className="text-[26px] sb-ac text-gray-800 mb-2 pt-9">{selectedDelivery.title}</h2>
            <p className="text-gray-600 text-[18px] max-w-[600px]  mx-auto text-center pb-10">{selectedDelivery.description}</p>
            </div>
          </div>
        </div>
      )}
</div>


  )
}